import layoutOrder from '@/layouts/layout-order.vue'

export default [
  {
    path: '',
    redirect: '',
    component: layoutOrder,
    /* hidden: true, */
    children: [{
      path: '/ordersPay',
      name: 'ordersPay',
      component: resolve => require.ensure([], () => resolve(require('@/views/orders/index.vue')), 'ordersPay'),
      meta: { title: '订单页', icon: '' }
    },
    {
      path: '/payOrders',
      name: 'payOrders',
      component: resolve => require.ensure([], () => resolve(require('@/views/orders/payOrders.vue')), 'payOrders'),
      meta: { title: '支付订单', icon: '' }
    },
    {
      path: '/shoppingCart',
      name: 'shoppingCart',
      component: resolve => require.ensure([], () => resolve(require('@/views/shoppingCart/index.vue')), 'shoppingCart'),
      meta: { title: '购物车', icon: '' }
    }]
  }
]
